import {
  Box,
  Container,
  Divider,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { contactContent } from "../../data/contactContent";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ScheduleCallButton from "../common/ScheduleCallButton";
import { scheduleCallConfig } from "../../data/scheduleCallContent";

const ContactSection: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      id="contact"
      sx={{
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
      }}
    >
      <Container maxWidth="lg">
        {/* Contenedor principal con logo + info */}
        <Stack
          direction={isMobile ? "column" : "row"}
          alignItems="center"
          justifyContent="center"
          sx={{ width: "100%" }}
        >
          {/* Logo */}
          <Box
            component="img"
            src="/assets/H_logo_w.png"
            alt="Hungerford Logo"
            sx={{
              height: 70,
              width: "auto",
              mx: isMobile ? "auto" : 0,
              mb: isMobile ? 2 : 0,
            }}
          />

          {/* Línea divisora (solo en desktop) */}
          {!isMobile && (
            <Divider
              orientation="vertical"
              flexItem
              sx={{
                borderColor: theme.palette.divider,
                mx: 8,
              }}
            />
          )}

          {/* Info de contacto */}
          <Box
            sx={{
              flex: 1,
              maxWidth: "min-content",
            }}
          >
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                textAlign: {
                  xs: "center",
                  md: "left",
                },
              }}
            >
              {contactContent.company}
            </Typography>

            {/* Info detallada */}
            <Stack spacing={2} mt={2} mr={2}>
              <Stack direction="row" alignItems="center" spacing={3}>
                <CalendarTodayIcon
                  sx={{
                    color: theme.palette.primary.main,
                    alignContent: "center",
                  }}
                />
                <Typography variant="body1">
                  {contactContent.description}
                </Typography>
              </Stack>

              {/* Email */}
              <Stack direction="row" alignItems="center" spacing={3}>
                <MailOutlineIcon sx={{ color: theme.palette.primary.main }} />
                <Typography
                  component="a"
                  href={`mailto:${contactContent.email}`}
                  sx={{
                    color: theme.palette.text.primary,
                    textDecoration: "none",
                  }}
                >
                  {contactContent.email}
                </Typography>
              </Stack>

              {/* Teléfono */}
              <Stack direction="row" alignItems="center" spacing={3}>
                <PhoneIcon sx={{ color: theme.palette.primary.main }} />
                <Typography
                  component="a"
                  href={`tel:${contactContent.phone}`}
                  sx={{
                    color: theme.palette.text.primary,
                    textDecoration: "none",
                  }}
                >
                  {contactContent.phone}
                </Typography>
              </Stack>
            </Stack>

            {/* Botón de agendar llamada */}
            <Box
              mt={2}
              sx={{
                textAlign: {
                  xs: "center",
                  md: "left",
                },
              }}
            >
              <ScheduleCallButton
                label={scheduleCallConfig.buttonLabel}
                // ghlUrl={scheduleCallConfig.ghlUrl}
              />
            </Box>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default ContactSection;
